(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["live-viewing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const randomBetween = (minimum, maximum) =>
      Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;

    const initializeBar = (bar) => {
      if (!bar || bar.hasAttribute('data-vittaro-ship-init')) return;
      bar.setAttribute('data-vittaro-ship-init', '1');

      const deliveryDays = Math.max(0, Number.parseInt(bar.dataset.deliveryDays || '14', 10));
      const minimumViewers = Math.max(1, Number.parseInt(bar.dataset.minViewers || '18', 10));
      const maximumViewers = Math.max(minimumViewers, Number.parseInt(bar.dataset.maxViewers || '34', 10));
      const configuredStartMin = Number.parseInt(bar.dataset.startMin || '22', 10);
      const configuredStartMax = Number.parseInt(bar.dataset.startMax || '29', 10);
      const startMinimum = Math.min(maximumViewers, Math.max(minimumViewers, configuredStartMin));
      const startMaximum = Math.max(startMinimum, Math.min(maximumViewers, configuredStartMax));
      const dateElement = bar.querySelector('[data-vittaro-ship-date]');
      const countElement = bar.querySelector('[data-vittaro-ship-count]');

      const deliveryDate = new Date();
      deliveryDate.setHours(12, 0, 0, 0);
      deliveryDate.setDate(deliveryDate.getDate() + deliveryDays);

      if (dateElement) {
        dateElement.textContent = new Intl.DateTimeFormat('en-GB', {
          weekday: 'short',
          day: 'numeric',
          month: 'long'
        }).format(deliveryDate);
      }

      if (!countElement) return;

      let viewers = randomBetween(startMinimum, startMaximum);
      countElement.textContent = String(viewers);

      const updateViewers = () => {
        if (!bar.isConnected) return;

        const change = Math.floor(Math.random() * 5) - 2;
        viewers += change;

        if (viewers < minimumViewers) viewers = minimumViewers;
        if (viewers > maximumViewers) viewers = maximumViewers;

        countElement.style.opacity = '0';
        window.setTimeout(() => {
          if (!bar.isConnected) return;
          countElement.textContent = String(viewers);
          countElement.style.opacity = '1';
        }, 180);

        window.setTimeout(updateViewers, 9000);
      };

      window.setTimeout(updateViewers, 9000);
    };

    const initializeAllBars = (scope = document) => {
      scope.querySelectorAll('[data-vittaro-ship-bar]').forEach(initializeBar);
    };

    initializeAllBars();

    if (!window.vittaroShipRouteEventsBound) {
      window.vittaroShipRouteEventsBound = true;

      document.addEventListener('DOMContentLoaded', () => initializeAllBars(), { once: true });
      document.addEventListener('shopify:section:load', (event) => initializeAllBars(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
